<template>
  <div class="cookie-banner primary white--text" role="region" aria-label="Cookie consent">
    <div class="cookie-banner__text">
      <strong>We value your privacy</strong>
      <div>
        We use strictly necessary cookies to run this site. With your consent we
        also use analytics cookies to understand how the site is used so we can
        improve it. You can accept all, reject non-essential cookies, or
        customise your choice. See our
        <a href="#" @click.prevent="$emit('more-info')">cookie policy</a>
        for details.
      </div>
    </div>
    <div class="cookie-banner__actions">
      <v-btn small outlined dark @click="$emit('customise')">Customise</v-btn>
      <v-btn small outlined dark @click="$emit('reject-all')">Reject all</v-btn>
      <v-btn small color="white" light @click="$emit('accept-all')">Accept all</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "CookieBanner",
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 500;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.25);
  padding: 16px 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  font-size: 14px;
}
.cookie-banner a {
  color: inherit;
}
.cookie-banner__text {
  flex: 1 1 380px;
  min-width: 0;
}
.cookie-banner__text strong {
  display: block;
  margin-bottom: 4px;
  font-size: 15px;
}
.cookie-banner__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}
.cookie-banner a {
  text-decoration: underline;
}
</style>
